export const paths = {
  home: "/",
  myshift: "/myshift",
  aboutUs: "/about",
  integration: "/integration",
  workforceManagement: "/workforce-management",
  analytics: "/analytics",
  contactUs: "/contact",
  privacyPolicy: "/privacy-policy",
  termsAndConditions: "/terms-and-conditions",
};
